module.exports = __webpack_public_path__ + "img/eye_bags_male.cee0e4cb.png";